import Swal from 'sweetalert2';
import addGuestButton from './add-guest-button';
import getGuests from "./get-guests";
import guestList from './guest-list';
import removeGuestButton from './remove-guest-button';

export default async function() {
    guestList.possibleGuests = await getGuests();
    guestList.refresh();

    let html = '<p class="cnaq-status-message cnaq-status-message--status">Please add guests to the guest list to be able to add to the reservation</p><ul class="cnaq-reserve-form__ul">';
    let guest;
    for (let index = 0, len = guestList.possibleGuests.length; index < len; index++) {
        guest = guestList.possibleGuests[index];
        if (guestList.isGuestAlreadyAdded(guest)) {
            html += `<li class="cnaq-reserve-form__li" data-id="${guest.id}"><span class="cnaq-reserve-form__guest-name">${guest.name}</span><button type="button" class="btn btn-danger cnaq-reserve-form__guest-remove-btn" data-id="${guest.id}">Remove</button></li>`;
        } else {
            html += `<li class="cnaq-reserve-form__li" data-id="${guest.id}"><span class="cnaq-reserve-form__guest-name">${guest.name}</span><button type="button" class="wi-btn wi-btn--blue cnaq-reserve-form__guest-add-btn" data-id="${guest.id}">Add</button></li>`;
        }
    }
    html += '</ul>';

    Swal.fire({
        title: 'Select a guest to add',
        html: html,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: `Done`,
        didRender: function(swalElement) {
            const guestAddButtons = swalElement.querySelectorAll('.cnaq-reserve-form__li .cnaq-reserve-form__guest-add-btn');
            guestAddButtons.forEach(element => {
                element.addEventListener('click', addGuestButton);
            });
            const guestRemoveButtons = swalElement.querySelectorAll('.cnaq-reserve-form__li .cnaq-reserve-form__guest-remove-btn');
            guestRemoveButtons.forEach(element => {
                element.addEventListener('click', removeGuestButton);
            });
        },
    }).then(result => {
        // Done

    })
}